const Footer = () => (
  <footer className="bg-[#111827] text-white py-16">
    <div className="max-w-6xl mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 pb-10 border-b border-white/10">
        <div>
          <img
            src="https://static.readdy.ai/image/6be4d011774e2550a2d57d89f2c7aba0/e88153e19b1786c6afcd14c824942ca0.png"
            alt="Direct Systems Marketing"
            className="h-10 w-auto object-contain mb-3"
          />
          <p className="text-white/50 text-sm max-w-xs leading-relaxed">
            Simple, scalable customer acquisition for local businesses.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-8 text-sm">
          <div>
            <h4 className="text-white/80 font-semibold mb-3 uppercase text-xs tracking-widest">Services</h4>
            <ul className="space-y-2 text-white/50">
              <li><a href="#solution" className="hover:text-orange-400 transition-colors">Google Ads Management</a></li>
              <li><a href="#solution" className="hover:text-orange-400 transition-colors">Landing Page Design</a></li>
              <li><a href="#solution" className="hover:text-orange-400 transition-colors">Lead Tracking</a></li>
              <li><a href="#solution" className="hover:text-orange-400 transition-colors">Campaign Optimization</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white/80 font-semibold mb-3 uppercase text-xs tracking-widest">Company</h4>
            <ul className="space-y-2 text-white/50">
              <li><a href="#how-it-works" className="hover:text-orange-400 transition-colors">How It Works</a></li>
              <li><a href="#results" className="hover:text-orange-400 transition-colors">Results</a></li>
              <li><a href="#offer" className="hover:text-orange-400 transition-colors">Strategy Call</a></li>
              <li><a href="#form" className="hover:text-orange-400 transition-colors">Contact Us</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-white/40 text-xs">
        <p>&copy; {new Date().getFullYear()} Direct Systems Marketing. All rights reserved.</p>
        <div className="flex items-center gap-5">
          <a href="#" rel="nofollow" className="hover:text-white/70 transition-colors">Privacy Policy</a>
          <span>|</span>
          <a href="#" rel="nofollow" className="hover:text-white/70 transition-colors">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
